import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { getAssetUrl } from '../../helper/assets';
import { Styles } from "./styles/mobileMenu.js";

function MobileMenu() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isCountriesOpen, setIsCountriesOpen] = useState(false);

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    return (
        <Styles>
            {/* Mobile Menu */}
            <section className="mobile-menu-area">
                <Container>
                    <Row>
                        <Col md="0" sm="12">
                            <div className="mb-topbar d-flex justify-content-between">
                                <div className="topbar-item">
                                    <p><i className="las la-phone"></i>+88001354839920</p>
                                </div>
                            </div>
                            <div className="mb-logo-area d-flex justify-content-between align-items-center">
                                <div className="mb-logo-box d-flex align-items-center">
                                    <div className="hm-button">
                                        <button 
                                            type="button"
                                            id="mb-sidebar-btn" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setIsSidebarOpen(!isSidebarOpen);
                                            }}
                                            style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }}
                                        >
                                            <i className="las la-bars" style={{ fontSize: '24px', color: '#11b264' }}></i>
                                        </button>
                                    </div>
                                    <div className="mb-logo">
                                        <Link to={process.env.PUBLIC_URL + "/"}>
                                            <img src={getAssetUrl("globalAbroad/logo_black.png")} alt="Global Abroad" style={{ maxHeight: '42px', width: 'auto' }} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Mobile Menu Sidebar */}
            <section className={`mb-sidebar ${isSidebarOpen ? 'opened' : ''}`} id="mb-sidebar-body">
                <div className="mb-sidebar-heading d-flex justify-content-between align-items-center">
                    <div><h5 style={{ margin: 0 }}>Menu</h5></div>
                    <div>
                        <button 
                            type="button" 
                            id="close-mb-sidebar" 
                            onClick={closeSidebar} 
                            style={{ background: 'transparent', border: 'none', color: '#ffffff', fontSize: '22px', cursor: 'pointer' }}
                        >
                            <i className="las la-times"></i>
                        </button>
                    </div>
                </div>
                <div className="mb-sidebar-menu">
                    <div className="mb-menu-item">
                        <Link to={process.env.PUBLIC_URL + "/"} onClick={closeSidebar} className="mb-menu-button" style={{ textDecoration: 'none' }}>
                            <p style={{ margin: 0 }}>Home</p>
                        </Link>
                    </div>
                    <div className="mb-menu-item">
                        <button 
                            className={`mb-menu-button ${isCountriesOpen ? 'active' : ''}`}
                            onClick={() => setIsCountriesOpen(!isCountriesOpen)}
                        >
                            <p style={{ margin: 0 }}>
                                Countries <i className={`las ${isCountriesOpen ? 'la-minus' : 'la-plus'}`}></i>
                            </p>
                        </button>
                        <div 
                            className={`mb-menu-content ${isCountriesOpen ? 'show' : ''}`}
                            style={{ 
                                maxHeight: isCountriesOpen ? '600px' : '0', 
                                overflow: 'hidden', 
                                transition: 'max-height 0.3s ease-in-out' 
                            }}
                        >
                            <ul className="list-unstyled">
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=malaysia"} onClick={closeSidebar}>Malaysia</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=malta"} onClick={closeSidebar}>Malta</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=greece"} onClick={closeSidebar}>Greece</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=usa"} onClick={closeSidebar}>USA</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=cyprus"} onClick={closeSidebar}>Cyprus</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=europe"} onClick={closeSidebar}>Europe</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=vietnam"} onClick={closeSidebar}>Vietnam</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=india"} onClick={closeSidebar}>India</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=australia"} onClick={closeSidebar}>Australia</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=canada"} onClick={closeSidebar}>Canada</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=germany"} onClick={closeSidebar}>Germany</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=uk"} onClick={closeSidebar}>UK</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=southkorea"} onClick={closeSidebar}>South Korea</Link></li>
                                <li><Link to={process.env.PUBLIC_URL + "/course-details?country=japan"} onClick={closeSidebar}>Japan</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="mb-menu-item">
                        <Link to={process.env.PUBLIC_URL + "/why_choose_us"} onClick={closeSidebar} className="mb-menu-button" style={{ textDecoration: 'none' }}>
                            <p style={{ margin: 0 }}>Why Choose Us</p>
                        </Link>
                    </div>
                    <div className="mb-menu-item">
                        <Link to={process.env.PUBLIC_URL + "/contact"} onClick={closeSidebar} className="mb-menu-button" style={{ textDecoration: 'none' }}>
                            <p style={{ margin: 0 }}>Contact</p>
                        </Link>
                    </div>
                    <div className="mb-menu-item">
                        <Link to={process.env.PUBLIC_URL + "/registration"} onClick={closeSidebar} className="mb-menu-button" style={{ textDecoration: 'none' }}>
                            <p style={{ margin: 0, color: '#11b264', fontWeight: 'bold' }}>
                                <i className="las la-clipboard-list" style={{ float: 'none', border: 'none', padding: 0, marginRight: '6px', fontSize: '16px' }}></i>
                                Apply Now
                            </p>
                        </Link>
                    </div>
                </div>
            </section>
            <div 
                className={`mb-sidebar-overlay ${isSidebarOpen ? 'visible' : ''}`} 
                id="mb-sidebar-overlay"
                onClick={closeSidebar}
            ></div>
        </Styles>
    );
}

export default MobileMenu;